import * as React from 'react'
import { useStoreActions } from '../store'

interface ExpressFlowIntroductionProps {
  serviceName: string
  description: string
}

export const ExpressFlowIntroduction = ({
  serviceName,
  description,
}: ExpressFlowIntroductionProps) => {
  const { navigateForward } = useStoreActions();
  return (
    <div className="express-flow-introduction max-w-72">
      <div className="express-flow-introduction__content">
        <span className="express-flow-introduction__service-name text-lg mt-5 mb-3 font-bold text-center block">{serviceName}</span>
        <p className="express-flow-introduction__description text-sm font-bold mb-6 text-center block" dangerouslySetInnerHTML={{ __html: description }}></p>    
        <div className="express-flow-introduction__actions flex flex-col gap-3">
          <button
            onClick={navigateForward}
            className="express-flow-introduction__button express-flow-introduction__button--primary rounded-full bg-pink-electric standard-form__next-button p-3 text-white w-full sm:w-60 md:w-80 font-semibold text-xl mb-3 text-center mx-auto"
          >
          Get Started          
          </button>          
        </div>   
      </div>
    </div>
  )
} 